module.exports = __webpack_public_path__ + "static/media/ResetEmail.10f58575.svg";